import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Activity, TrendingUp, DollarSign, MapPin, Clock } from 'lucide-react';

const TripsActivity: React.FC = () => {
  const [stats, setStats] = useState({ total: 0, spent: 0, distance: 0, avgRating: 0 });
  const [activeCard, setActiveCard] = useState(0);

  useEffect(() => {
    // Cancelled trips are never billed - they don't count toward any stat.
    const history = JSON.parse(localStorage.getItem('rideHistory') || '[]')
      .filter((r: any) => r.status !== 'cancelled');
    const total = history.length;
    const spent = history.reduce((sum: number, r: any) => sum + (r.price || 0), 0);
    const distance = history.reduce((sum: number, r: any) => sum + (r.distance || 0), 0);
    const avgRating = total > 0 ? history.reduce((sum: number, r: any) => sum + (r.rating || 5), 0) / total : 0;
    setStats({ total, spent, distance: Math.round(distance), avgRating: Math.round(avgRating * 10) / 10 });
  }, []);

  const cards = [
    { icon: Activity, iconColor: 'text-safaricab-gold', value: stats.total, label: 'Total Rides' },
    { icon: DollarSign, iconColor: 'text-green-500', value: `KES ${stats.spent.toLocaleString()}`, label: 'Total Spent' },
    { icon: MapPin, iconColor: 'text-blue-500', value: `${stats.distance} km`, label: 'Total Distance' },
    { icon: TrendingUp, iconColor: 'text-purple-500', value: stats.avgRating, label: 'Avg Rating' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCard((prev) => (prev + 1) % cards.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [cards.length]);

  const current = cards[activeCard];
  const Icon = current.icon;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="px-4 pt-4 pb-24">
      <h2 className="text-white font-bold text-xl mb-4">Trips Activity</h2>
      <div className="relative h-32">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeCard}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="absolute inset-0 bg-safaricab-card rounded-xl p-4 border border-white/10 flex flex-col justify-center"
          >
            <Icon className={`w-6 h-6 ${current.iconColor} mb-2`} />
            <p className="text-2xl text-white font-bold">{current.value}</p>
            <p className="text-white/50 text-xs">{current.label}</p>
          </motion.div>
        </AnimatePresence>
      </div>
      <div className="flex justify-center gap-1.5 mt-3">
        {cards.map((_, i) => (
          <div
            key={i}
            className={`h-1.5 rounded-full transition-all ${i === activeCard ? 'w-4 bg-safaricab-gold' : 'w-1.5 bg-white/20'}`}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default TripsActivity;
